import React from 'react';
import { Size } from '../../types';
import { colors, sizes, eventDisplayMap } from '../../styles';
import Icon from './icon';

export interface Props {
  eventType: string;
  className?: string;
  size?: Size;
}

export default class EventIcon extends React.Component<Props, any> {
  public static defaultProps: Props = {
    size: 'md',
    eventType: 'acceleration',
  };

  render() {
    const { eventType, size } = this.props;
    const { kind, icon } = eventDisplayMap[eventType];
    return <Icon size={size} icon={icon} baseColor={colors[kind]} />;
  }
}
